import React from "react"

import PropTypes from "prop-types"
import {Progress, Radio} from "semantic-ui-react"

import {getDataTestId} from "../../utils/stringUtil"
import MessageComplementaire from "../MessageComplementaire"
import texts from "./texts"

import "./style.scss"

export const AMOUNT_TILE_VARIANTS = {COMPTE: "compte", SAP: "sap", TITRE: "titre", RADIO: "radio"}

const AmountTile = ({
    ancienMillesime = false,
    description = undefined,
    details,
    displayNbTitres = false,
    messageComplementaire = undefined,
    onClick = undefined,
    selected = false,
    solde,
    title,
    titresRestants = undefined,
    total = 1,
    variant,
}) => (
    <article
        aria-label={`${title} - Solde : ${solde.toFixed(2)} €`}
        className={`amount-tile variant-${variant}`}
        data-testid={getDataTestId(title, "tuileMontant")}
        onClick={onClick}
        tabIndex={variant === AMOUNT_TILE_VARIANTS.RADIO ? 0 : -1}
    >
        {/* HEADER */}
        {variant !== AMOUNT_TILE_VARIANTS.RADIO && (
            <div aria-hidden="true" className={`amount-tile-header${ancienMillesime ? " ancien-millesime" : ""}`} />
        )}
        {/* CONTENT */}
        <div className={`amount-tile-content${selected ? " selected" : ""}`}>
            {/* TOP LINE */}
            <div className="top-line">
                {variant === AMOUNT_TILE_VARIANTS.RADIO && <Radio checked={selected} tabIndex={-1} />}
                <div>
                    <h4>{title}</h4>
                    {variant === AMOUNT_TILE_VARIANTS.RADIO && description && (
                        <p className="description">{description}</p>
                    )}
                </div>
            </div>
            {/* SOLDE */}
            <p aria-label={`${solde.toFixed(2)} euros`} className="solde">
                {solde.toFixed(2)} €
            </p>
            {/* PROGRESS BAR */}
            {variant === AMOUNT_TILE_VARIANTS.SAP && total && (
                <>
                    <Progress
                        aria-hidden="true"
                        className="bar-container"
                        percent={total > 0 ? 100 - (solde * 100) / total : 0}
                        small
                    />
                    <p className="totalCounter">{texts.totalCounterSAP(total)}</p>
                </>
            )}
            {/* DETAILS */}
            <p className="details">{details}</p>
            {/* NB TITRES */}
            {(variant === AMOUNT_TILE_VARIANTS.TITRE || displayNbTitres) && (
                <p className="titres">{titresRestants ? titresRestants : texts.aucunTitre}</p>
            )}
            {/* MSG COMPLEMENTAIRE */}
            {messageComplementaire && <MessageComplementaire content={messageComplementaire} type="info" />}
        </div>
    </article>
)

AmountTile.propTypes = {
    ancienMillesime: PropTypes.bool,
    description: PropTypes.string,
    details: PropTypes.string.isRequired,
    displayNbTitres: PropTypes.bool,
    messageComplementaire: PropTypes.string,
    onClick: PropTypes.func,
    selected: PropTypes.bool,
    solde: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    titresRestants: PropTypes.string,
    total: PropTypes.number,
    variant: PropTypes.oneOf(Object.values(AMOUNT_TILE_VARIANTS)).isRequired,
}

export default AmountTile
